import { ChangePasswordForm } from '@/components/change-password-form'
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router'
import { resetResetPasswordAuthResetPasswordPostMutation } from '@/client/@tanstack/react-query.gen'
import { useToast } from '@/hooks/use-toast'
import { useMutation } from '@tanstack/react-query'

interface UpdatePasswordSearch {
  token: string | undefined
}

export const Route = createFileRoute('/_login_forms/_forgot_password/update-password')({
  validateSearch: (search: Record<string, unknown>): UpdatePasswordSearch => ({
    token: search['token'] as string | undefined, // eslint-disable-line dot-notation
  }),
  beforeLoad: () => ({
    title: 'Update Password',
    description: 'Enter below to change your password',
  }),
  component: UpdatePasswordPage,
})
function UpdatePasswordPage() {
  const navigate = useNavigate()
  const { toast } = useToast()
  const { token } = Route.useSearch()

  const handleSubmit = useMutation({
    ...resetResetPasswordAuthResetPasswordPostMutation(),
    onError: (error) => {
      if (error instanceof Error) {
        toast({ title: error.message, variant: 'destructive' })
      }
    },
    onSuccess: () => {
      toast({
        title: 'Password updated successfully',
        variant: 'success',
      })
      navigate({ to: '/' })
    },
  })

  return (
    <div>
      <ChangePasswordForm
        submitLabel="Update Password"
        submittingLabel="Updating..."
        onSubmit={async (password) => {
          await handleSubmit.mutateAsync({ body: { password, token: token! } })
        }}
      />
      <div className="mt-4 text-center text-xs text-muted-foreground">
        <Link to="/login" className="hover:underline text-primary">
          Back to Login
        </Link>
      </div>
    </div>
  )
}
